export const CollectionsLoading = () => {
  return (
    <div className="animate-pulse flex space-s-4 mt-3 mx-1 px-2">
      <div className="space-y-3 flex-1">
        <div className="h-4 bg-skeleton rounded-full w-3/4" />
        <div className="h-4 bg-skeleton rounded-full w-11/12" />
        <div className="h-4 bg-skeleton rounded-full w-5/6" />
        <div className="h-4 bg-skeleton rounded-full w-4/6" />
        <div className="h-4 bg-skeleton rounded-full w-11/12" />
        <div className="h-4 bg-skeleton rounded-full w-5/6" />
      </div>
    </div>
  )
}
